module.exports = __webpack_public_path__ + "img/26.f2766f24.jpg";